import { displayHighSchoolName } from '../highSchoolSearch';

//#region Grade
export const gradeOptions = [
  { value: '',     name: '- Select -' },
  { value: '9th',  name: '9th' },
  { value: '10th', name: '10th' },
  { value: '11th', name: '11th'  },
  { value: '12th', name: '12th'  },
];
//#endregion

//#region Academic Year selection *
export const academicOptions = [
  { value: '- Select -' },
  { value: '2000 - 2001' },
  { value: '2001 - 2002' },
  { value: '2002 - 2003' },
  { value: '2003 - 2004' },
  { value: '2004 - 2005' },
  { value: '2005 - 2006' },
  { value: '2006 - 2007' },
  { value: '2007 - 2008' },
  { value: '2008 - 2009' },
  { value: '2009 - 2010' },
  { value: '2010 - 2011' },
  { value: '2011 - 2012' },
  { value: '2012 - 2013' },
  { value: '2013 - 2014' },
  { value: '2014 - 2015' },
  { value: '2015 - 2016' },
  { value: '2016 - 2017' },
  { value: '2017 - 2018' },
  { value: '2018 - 2019' },
  { value: '2019 - 2020' },
  { value: '2020 - 2021' },
  { value: '2021 - 2022' },
  { value: '2022 - 2023' },
  { value: '2023 - 2024' },
  { value: '2024 - 2025' },
  { value: '2025 - 2026' },
  { value: '2026 - 2027' },
  { value: '2027 - 2028' },
  { value: '2028 - 2029' },

];
//#endregion

//#region Date received or to be received
const years = {
  start: 1924,
  end: Math.max(2030, new Date().getFullYear() + 1),
};

const receivedYearCount = years.end + 1 - years.start;

export const receivedYears = [
  '- Select -',
  ...Array.from({ length: receivedYearCount }, (_, i) => ({
    value: years.end - i,
  })),
];
//#endregion

//#region Other grading system → auto-text
const OTHER_GRADING_SENTENCE_PATTERN =
  /^I selected "Other" for .+ grading system because it uses a .+ grading scale\.$/;

const isTruthyBoolean = (value: unknown) =>
  value === true || value === 'true' || value === 1 || value === '1';

export const hasOtherGradingScaleSelected = (school: any) =>
  isTruthyBoolean(school?.grading_scale_is_other);

export const buildOtherGradingSentence = (schoolName: string, gradingSystem?: string) => {
  const gradingScale = gradingSystem?.trim() || '<specific grading system>';
  const school = schoolName?.trim() || 'my high school';
  return `I selected "Other" for ${school} grading system because it uses a ${gradingScale} grading scale.`;
};

const isAutoOtherGradingLine = (line: string) => OTHER_GRADING_SENTENCE_PATTERN.test(line);

const getOtherGradingAutoSentences = (schools: any[]) =>
  Array.from(
    new Set(
      schools
        .filter((school) => hasOtherGradingScaleSelected(school))
        .map((school) =>
          buildOtherGradingSentence(
            displayHighSchoolName(school) || school.high_school_name,
            school.other_grading_system
          )
        )
    )
  );

export const syncTextWithOtherGradingSchools = (
  currentText: string | undefined | null,
  schools: any[]
): string => {
  const autoSentences = getOtherGradingAutoSentences(schools);

  const manualLines = (currentText ?? '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line && !isAutoOtherGradingLine(line));

  return [...autoSentences, ...manualLines].join('\n').trim();
};
//#endregion
